import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { TFieldValidationResult } from "."
import { hasDefaultComponent } from "../../../utils/pageModelUtils";


export const phoneFieldValidations = async (validatingState: TAcquisitionProviderFacade): Promise<TFieldValidationResult> => {
    const { isAuthor, isAdobeMode, usePhoneApi, phoneValidationApi } = validatingState.getCurrentMetaAcquisitionFlowState();

    let validationResult: TFieldValidationResult = {};
    const { phoneNumber } = validatingState.getPersonalInformation();
    const phoneAndIncomeInfo = validatingState.getPhoneAndIncomeInfo();
    
    if (
        hasDefaultComponent('cob-corp-acquisition/components/creditonebank/personal-information-form')
        || hasDefaultComponent('cob-corp-acquisition/components/creditonebank/phone-number-and-income')
    ) {

        const phoneNum = phoneNumber.value || phoneAndIncomeInfo.phoneNumber?.value || '';
        if (
            !phoneNum || (phoneNum !== '' && phoneNum.trim().length !== 10)
        ) {
            validationResult['PrimaryPhoneNumber'] = 'RequiredField';
    
        } else if (
            ((!isAuthor && !isAdobeMode) || (isAdobeMode && usePhoneApi))
            && !(await phoneValidationApi(phoneNumber.value.replace(/[^0-9]/g, '').slice(0, 10)))
        ) {
            validationResult['PrimaryPhoneNumber'] = 'ThirdParty';
        }
    }


    return validationResult;
}